import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.aufgaben-benutzer-berechtigungen-excel';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabenBenutzerBerechtigungenExcelEffects {

    AufgabenBenutzerBerechtigungenExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_AUFGABEN_BENUTZER_BERECHTIGUNGEN_EXCEL),
        mergeMap((x: ac.GetAufgabenBenutzerBerechtigungenExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAufgabenBenutzerBerechtigungenExcel().pipe(
                map((result: any) => {
                    return new ac.GetAufgabenBenutzerBerechtigungenExcelErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAufgabenBenutzerBerechtigungenExcelFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenReportingService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenReportingService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenReportingService);
        }
        return this.service;
    }
}
